(function () {
  if ([...document.querySelectorAll('.masthead-nav')].length) {
    const productLinks = [
      ...document.querySelectorAll('.masthead-nav__mega__content .third a'),
      ...document.querySelectorAll('.masthead-nav__mega__content .second a'),
    ];
    productLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const activeIndustry =
          document
            .querySelector('.masthead-nav__mega__content .first a.active')
            .getAttribute('data-industry') || null;
        if (activeIndustry !== null) {
          createCookie(activeIndustry);
        }
      });
    });
  } else {
    //sets industry cookie basked on industry selected (in the navigation)
    const industryItems = document.querySelectorAll('[data-industry]');
    industryItems.forEach((item) => {
      item.addEventListener('click', function () {
        const industrySelectedCode = item.getAttribute('data-industry');
        createCookie(industrySelectedCode);
      });
    });
  }

  // deal with products page bindings separately
  if ([...document.querySelectorAll('.product-list-wrapper')].length) {
    const industryLinks = [
      ...document.querySelectorAll('.product-list-wrapper [data-industry-id]'),
    ];
    industryLinks.forEach((industry) => {
      industry.addEventListener('click', (event) => {
        const industryTarget = event.target.closest('[data-industry-id]');
        const industryId = industryTarget.getAttribute('data-industry-id');
        industryId !== 'other' && createCookie(industryId);
      });
    });
  }

  function createCookie(industry) {
    document.cookie = `jcb-user-industry=${industry}; path='/'; SameSite=None; Secure`;
  }
})();
